module.exports = __webpack_public_path__ + "static/media/planning-hero-2x.6d149606.png";